/**
 * Asynchronously loads the component for HomePage
 */

import React from 'react';
import loadable from '../../utils/loadable';
import LoadingIndicator from '../../components/LoadingIndicator';

export const CompaniesListing = loadable(() => import('./Companies'), { fallback: <LoadingIndicator /> });

export const CompanyDetails = loadable(() => import('./CompanyDetails'), { fallback: <LoadingIndicator /> });
